module.exports = __webpack_public_path__ + "static/media/profile-img.85a573f7.jpeg";